import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';

export const Checkbox = ({ 
  label,
  error, 
  helperText,
  layout,
  labelCol,
  wrapperCol,
  required,
  noLabel,
  ...props 
}) => {
  // For use in contract forms where we want to render the checkbox directly
  // with its own label without InputWrapper
  if (noLabel) {
    return <AntCheckbox {...props}>{label}</AntCheckbox>;
  }
  
  return (
    <InputWrapper
      label={label}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <AntCheckbox {...props} />
    </InputWrapper>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  required: PropTypes.bool,
  noLabel: PropTypes.bool,
};

export default Checkbox; 